import axios from "axios";
import url1 from '../../config.js'
const url = `${url1.url}/api/tanpura`;

export default class Tanpura {
    constructor(tanpura = {}) {
        this.tanpuraAudio = tanpura.tanpuraAudio||"",
        this.tanpuraStatus=tanpura.tanpuraStatus||true 
    }
    static get = (token) => {
        console.log('get tanpura client')
        return axios.get(url, {headers:{'x-auth-token':token}});
    }
    static putTanpura(tanpura_id, formData, token) {
        // console.log('put orderstatus client')
        return axios.put(`${url}/changetanpura/${tanpura_id}`,formData, {headers:{'x-auth-token':token}});
    }
}